import Image from "next/image";
import {DesktopSize, MobileSize} from "@/components/responsive";
import Rating from "react-rating";
import {memo, useEffect, useState} from "react";
import moment from "moment-jalaali";
import {EMOJI_IMAGES, LOCAL_IMAGE_URL} from "@/constants/general-constants";
import {isEmpty} from "@/utils/global-functions";

const CommentCard = memo(function CommentCard({data = {}}) {

    const [showMore, setShowMore] = useState(false);
    const [message, setMessage] = useState(data.message || "");

    useEffect(() => {
        if (data.message?.length > 240) {
            setShowMore(true);
            setMessage(data.message.slice(0, 240));
        }
    }, [data.message]);

    const loadMore = () => {
        setMessage(data.message);
        setShowMore(false)
    }

    return (
        <>
            <div
                className="rounded-[1.75rem] px-7 border border-pol-light-purple-6 bg-white py-5 mt-6">
                <div className="flex items-start gap-x-3 lg:gap-x-[1.375rem]">
                    <div className="text-center">
                        <div
                            className="relative rounded-xl lg:rounded-[1.125rem] overflow-hidden w-12 h-12 lg:w-[5.688rem] lg:h-[5.688rem]">
                            <Image
                                src={LOCAL_IMAGE_URL + "emojies/" + EMOJI_IMAGES[!isEmpty(data.emoji) ? data.emoji : 0]}
                                alt={data.name}
                                fill
                                className="object-cover"/>
                        </div>
                        <DesktopSize>
                            <time
                                className="inline-block font-semibold text-sm text-pol-gray-350 mt-4">
                                {moment(data.created_at || "").format("jYYYY/jMM/jDD")}
                            </time>
                        </DesktopSize>
                    </div>
                    <div className="pt-1.5 w-full">
                        <div className="flex items-center justify-between">
                            <h3 className="font-bold text-pol-dark-800">{data.name}</h3>
                            <div className="text-lg">
                                <Rating
                                    readonly
                                    direction="ltr"
                                    initialRating={data.rating}
                                    emptySymbol={<i className="icon-filled-star text-pol-gray-100 mr-0.5"/>}
                                    fullSymbol={<i className="icon-filled-star text-pol-orange mr-0.5"/>}/>
                            </div>
                        </div>
                        <MobileSize>
                            <time
                                className="font-semibold text-xs lg:text-sm text-pol-gray-350 mt-1 text-left">
                                {moment(data.created_at || "").format("jYYYY/jMM/jDD")}
                            </time>
                        </MobileSize>
                        <DesktopSize>
                            <p className="text-pol-gray-600 text-justify leading-[170%] mt-4">{message}
                                {
                                    showMore ?
                                        <span className="text-pol-blue cursor-pointer"
                                              onClick={loadMore}>بیشتر...</span> : null
                                }
                            </p>
                        </DesktopSize>
                    </div>
                </div>
                <MobileSize>
                    <p className="text-pol-gray-600 text-justify leading-[170%] mt-2">{message}
                        {
                            showMore ?
                                <span className="text-pol-blue cursor-pointer"
                                      onClick={loadMore}>بیشتر...</span> : null
                        }
                    </p>
                </MobileSize>
            </div>

            {
                data.admin_reply ?
                    <div className="px-7 bg-pol-light pt-6 pb-4 mr-7 mt-4 rounded-[1.75rem] px-7 border border-pol-light-purple-6">
                        <div className="flex items-center justify-between">
                            <h3 className="font-bold text-sm text-pol-gray-475">
                                <i className="icon-layouts text-base ml-2.5"/>
                                <span>مدیر وبلاگ</span>
                            </h3>
                            <DesktopSize>
                                <time className="inline-block font-semibold text-sm text-pol-gray-350">
                                    {moment(data.created_at || "").format("jYYYY/jMM/jDD")}
                                </time>
                            </DesktopSize>
                        </div>
                        <p className="text-pol-dark-800 text-justify leading-[170%] mt-2.5">{data.admin_reply.message}</p>
                    </div> : null
            }
        </>
    )
}, (prevProps, nextProps) => {
    return prevProps.id === nextProps.id
})

export default CommentCard;
